const Contactos = () => {
  return (
    <div>
      <section className='relative bg-orange-50 py-20 flex justify-center items-center'>
        {/* Title */}
        <h2 className='text-4xl font-Anton text-orange-900'>CONTACT</h2>

        {/* Floating Shape 1 (top) */}
        <div className='absolute top-6 left-1/2 transform -translate-x-1/2 w-[12px] h-[12px]'>
          <img
            src='./Button.png' // your image src here
            alt='Floating Dot'
            className='w-full h-full object-contain'
          />
        </div>

        {/* Floating Shape 2 (bottom-left) */}
        <div className='absolute bottom-3 left-52 w-[80px] h-[80px]'>
          <img
            src='./wrig.png'
            alt='Floating Shape Left'
            className='w-full h-full object-contain'
          />
        </div>

        {/* Floating Shape 3 (bottom-right) */}
        <div className='absolute bottom-12 right-64 w-[15px] h-[15px]'>
          <img
            src='./Button 2.png'
            alt='Floating Dot Right'
            className='w-full h-full object-contain'
          />
        </div>
      </section>

      {/* Section 2 */}
      <section
        className='relative bg-gray-50 bg-cover bg-center h-full w-full py-20 flex justify-center items-center'
        style={{ backgroundImage: "url('./Backky.jpg')" }}
      >
        {/* Contact Card */}
        <div className='bg-white shadow-lg rounded-lg p-10 space-y-6 max-w-md w-full relative z-10'>
          <h2 className='text-2xl font-Anton text-orange-900 mb-2'>
            Get in Touch
          </h2>
          <p className='text-gray-600 font-semibold mb-4'>
            Contact us through any of the following outlets
          </p>

          {/* Location */}
          <div className='flex items-start mb-6'>
            <div className=' w-14 h-14 flex justify-center items-center rounded-full border border-gray-300 mr-4'>
              <svg
                width='20'
                height='20'
                viewBox='0 0 29 33'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M15.433 31.2C15.161 31.3953 14.8345 31.5004 14.4996 31.5004C14.1647 31.5004 13.8383 31.3953 13.5663 31.2C5.51797 25.4633 -3.0237 13.6633 5.6113 5.13667C7.98187 2.80475 11.1744 1.49854 14.4996 1.5C17.833 1.5 21.0313 2.80833 23.388 5.135C32.023 13.6617 23.4813 25.46 15.433 31.2Z'
                  stroke='#61300D'
                  stroke-width='2.5'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                />
                <path
                  d='M14.4993 16.5C15.3834 16.5 16.2312 16.1489 16.8564 15.5237C17.4815 14.8986 17.8327 14.0508 17.8327 13.1667C17.8327 12.2827 17.4815 11.4348 16.8564 10.8097C16.2312 10.1846 15.3834 9.83337 14.4993 9.83337C13.6153 9.83337 12.7674 10.1846 12.1423 10.8097C11.5172 11.4348 11.166 12.2827 11.166 13.1667C11.166 14.0508 11.5172 14.8986 12.1423 15.5237C12.7674 16.1489 13.6153 16.5 14.4993 16.5Z'
                  stroke='#61300D'
                  stroke-width='2.5'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                />
              </svg>
            </div>
            <div className='space-y-2'>
              <p className='text-orange-900 font-semibold'>
                <span className='font-normal text-black'>Location</span> <br />3
                Adamu Ciroma Cresent, <br /> Off Ebitu Ukiwe Street, <br />{' '}
                Jabi, Abuja 900108
              </p>
            </div>
          </div>

          {/* Phone */}
          <div className='flex items-start mb-6'>
            <div className='w-14 h-14 flex justify-center items-center rounded-full border border-gray-300 mr-4'>
              <svg
                width='26'
                height='26'
                viewBox='0 0 26 26'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M24.3565 24.5209C24.2371 25.1416 23.8682 25.4573 23.2498 25.4681C17.0008 25.5772 11.6244 23.4572 7.12075 19.108C2.61708 14.7589 0.310701 9.45977 0.201624 3.21072C0.190829 2.59232 0.493494 2.21263 1.10962 2.07165L6.16652 0.811327C6.78207 0.637797 7.22544 0.857957 7.49661 1.47181L9.93544 6.89882C10.1724 7.4156 10.0664 7.87325 9.61756 8.27177L6.73007 10.7151C7.64237 12.6201 8.85988 14.2918 10.3826 15.7303C11.9059 17.2013 13.6191 18.3597 15.5222 19.2055L17.9121 16.2337C18.2621 15.7718 18.7158 15.6499 19.2731 15.8681L24.7819 18.116C25.3723 18.3662 25.5915 18.8019 25.4396 19.4231L24.3565 24.5209Z'
                  fill='#61300D'
                />
              </svg>
            </div>
            <div className='space-y-2'>
              <p className='text-orange-900 font-semibold '>
                <span className='font-normal text-black'>Phone:</span> <br />
                +2347025050009
              </p>
            </div>
          </div>

          {/* Email */}
          <div className='flex items-start'>
            <div className='w-14 h-14 flex justify-center items-center rounded-full border border-gray-300 mr-4'>
              <svg
                width='26'
                height='19'
                viewBox='0 0 26 19'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M24.5316 6.45117C24.6293 6.35352 24.727 6.33724 24.8246 6.40234C24.9548 6.46745 25.0199 6.5651 25.0199 6.69531V16.6562C25.0199 17.3073 24.7921 17.8607 24.3363 18.3164C23.8806 18.7721 23.3272 19 22.6762 19H2.36367C1.71263 19 1.15925 18.7721 0.703516 18.3164C0.247787 17.8607 0.0199223 17.3073 0.0199223 16.6562V6.69531C0.0199223 6.5651 0.0687504 6.48372 0.166407 6.45117C0.296615 6.38607 0.410547 6.38607 0.508204 6.45117C1.58242 7.26497 4.08893 9.10417 8.02773 11.9688C8.09284 12.0339 8.30443 12.2129 8.6625 12.5059C9.05313 12.7988 9.36237 13.0267 9.59023 13.1895C9.8181 13.3197 10.1111 13.4987 10.4691 13.7266C10.8272 13.9219 11.169 14.0684 11.4945 14.166C11.8526 14.2637 12.1944 14.3125 12.5199 14.3125C12.8129 14.3125 13.1059 14.2799 13.3988 14.2148C13.6918 14.1172 13.9685 14.0195 14.2289 13.9219C14.4893 13.7917 14.766 13.6289 15.059 13.4336C15.352 13.2383 15.5961 13.0755 15.7914 12.9453C15.9867 12.7826 16.2146 12.6035 16.475 12.4082C16.7354 12.2129 16.9145 12.0664 17.0121 11.9688C20.8533 9.20182 23.3598 7.36263 24.5316 6.45117ZM12.5199 12.75C12.2595 12.75 11.934 12.6686 11.5434 12.5059C11.1853 12.3105 10.8923 12.1478 10.6645 12.0176C10.4366 11.8548 10.0948 11.6107 9.63906 11.2852C9.21589 10.9271 8.98802 10.748 8.95547 10.748C4.98411 7.85091 2.15208 5.7513 0.459375 4.44922C0.166407 4.22135 0.0199223 3.91211 0.0199223 3.52148V2.59375C0.0199223 1.94271 0.247787 1.38932 0.703516 0.933594C1.15925 0.477865 1.71263 0.25 2.36367 0.25H22.6762C23.3272 0.25 23.8806 0.477865 24.3363 0.933594C24.7921 1.38932 25.0199 1.94271 25.0199 2.59375V3.52148C25.0199 3.91211 24.8734 4.22135 24.5805 4.44922C22.9854 5.6862 20.1534 7.78581 16.0844 10.748C16.0518 10.748 15.8077 10.9271 15.352 11.2852C14.9288 11.6107 14.6033 11.8548 14.3754 12.0176C14.1475 12.1478 13.8383 12.3105 13.4477 12.5059C13.0896 12.6686 12.7803 12.75 12.5199 12.75Z'
                  fill='#61300D'
                />
              </svg>
            </div>
            <div className='space-y-2'>
              <p className='text-orange-900 font-semibold'>
                <span className='font-normal text-black'>Email:</span> <br />
                NGA.Enrichdlp@care.org
              </p>
            </div>
          </div>
        </div>

        {/* Decorative Image (bottom right) */}
        <div className='absolute bottom-2 right-40 w-[220px] h-[220px] opacity-80'>
          <img
            src='./2.png' // your decorative asset here
            alt='Decorative Shape'
            className='w-full h-full object-contain'
          />
        </div>
      </section>
      {/* footer */}
      <footer
        className='bg-[#121212] bg-cover bg-center text-white font-raleway'
        style={{ backgroundImage: "url('./Background2.png')" }}
      >
        {/* Top Contact Row */}
        <div className='grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-700'>
          {/* Google Play */}
          <div className='flex items-center justify-center py-6 space-x-3 mt-[14px]'>
            <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400'>
              <svg
                width='29'
                height='34'
                viewBox='0 0 29 34'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M15.3529 31.7C15.0809 31.8953 14.7544 32.0004 14.4196 32.0004C14.0847 32.0004 13.7582 31.8953 13.4862 31.7C5.43789 25.9633 -3.10378 14.1633 5.53122 5.63667C7.90179 3.30475 11.0943 1.99854 14.4196 2C17.7529 2 20.9512 3.30833 23.3079 5.635C31.9429 14.1617 23.4012 25.96 15.3529 31.7Z'
                  stroke='white'
                  stroke-width='2.5'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                />
                <path
                  d='M14.4193 16.9997C15.3033 16.9997 16.1512 16.6485 16.7763 16.0234C17.4014 15.3982 17.7526 14.5504 17.7526 13.6663C17.7526 12.7823 17.4014 11.9344 16.7763 11.3093C16.1512 10.6842 15.3033 10.333 14.4193 10.333C13.5352 10.333 12.6874 10.6842 12.0622 11.3093C11.4371 11.9344 11.0859 12.7823 11.0859 13.6663C11.0859 14.5504 11.4371 15.3982 12.0622 16.0234C12.6874 16.6485 13.5352 16.9997 14.4193 16.9997Z'
                  stroke='white'
                  stroke-width='2.5'
                  stroke-linecap='round'
                  stroke-linejoin='round'
                />
              </svg>
            </div>
            <div className=''>
              <p className='text-orange-500 text-sm font-raleway'>Location</p>
              <span className='text-white text-sm font-bold '>
                3 Adamu Ciroma Cresent, <br /> Off Ebitu Ukiwe Street, <br />{' '}
                Jabi, Abuja 900108
              </span>
            </div>
          </div>

          {/* Phone Number */}
          <div className='flex items-center justify-center py-6 space-x-3 space-y-2 mt-[14px]'>
            <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400'>
              <svg
                width='26'
                height='26'
                viewBox='0 0 26 26'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M24.3575 24.5212C24.2381 25.1418 23.8692 25.4576 23.2508 25.4684C17.0018 25.5774 11.6254 23.4574 7.12173 19.1083C2.61805 14.7591 0.311678 9.46001 0.2026 3.21096C0.191806 2.59257 0.494471 2.21288 1.11059 2.07189L6.16749 0.811571C6.78305 0.638041 7.22641 0.858202 7.49758 1.47205L9.93642 6.89907C10.1733 7.41584 10.0674 7.87349 9.61854 8.27201L6.73105 10.7154C7.64334 12.6203 8.86085 14.292 10.3836 15.7305C11.9069 17.2015 13.6201 18.36 15.5231 19.2058L17.9131 16.2339C18.2631 15.772 18.7168 15.6502 19.2741 15.8683L24.7829 18.1163C25.3733 18.3664 25.5925 18.8021 25.4406 19.4234L24.3575 24.5212Z'
                  fill='white'
                />
              </svg>
            </div>
            <div className=''>
              <p className='text-orange-500 text-sm font-raleway pl-3'>
                Phone:
              </p>
              <span className='text-white text-sm font-Sora px-3'>
                +2347025050009
              </span>
            </div>
          </div>
          {/* Email */}
          <div className='flex items-center justify-center py-6 space-x-3 space-y-2 mt-[14px]'>
            <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400'>
              <svg
                width='26'
                height='20'
                viewBox='0 0 26 20'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M25.4115 6.95117C25.5092 6.85352 25.6068 6.83724 25.7045 6.90234C25.8347 6.96745 25.8998 7.0651 25.8998 7.19531V17.1562C25.8998 17.8073 25.6719 18.3607 25.2162 18.8164C24.7605 19.2721 24.2071 19.5 23.5561 19.5H3.24356C2.59251 19.5 2.03913 19.2721 1.5834 18.8164C1.12767 18.3607 0.899805 17.8073 0.899805 17.1562V7.19531C0.899805 7.0651 0.948633 6.98372 1.04629 6.95117C1.1765 6.88607 1.29043 6.88607 1.38809 6.95117C2.46231 7.76497 4.96882 9.60417 8.90762 12.4688C8.97272 12.5339 9.18431 12.7129 9.54238 13.0059C9.93301 13.2988 10.2423 13.5267 10.4701 13.6895C10.698 13.8197 10.991 13.9987 11.349 14.2266C11.7071 14.4219 12.0489 14.5684 12.3744 14.666C12.7325 14.7637 13.0743 14.8125 13.3998 14.8125C13.6928 14.8125 13.9857 14.7799 14.2787 14.7148C14.5717 14.6172 14.8484 14.5195 15.1088 14.4219C15.3692 14.2917 15.6459 14.1289 15.9389 13.9336C16.2318 13.7383 16.476 13.5755 16.6713 13.4453C16.8666 13.2826 17.0945 13.1035 17.3549 12.9082C17.6153 12.7129 17.7943 12.5664 17.892 12.4688C21.7331 9.70182 24.2396 7.86263 25.4115 6.95117ZM13.3998 13.25C13.1394 13.25 12.8139 13.1686 12.4232 13.0059C12.0652 12.8105 11.7722 12.6478 11.5443 12.5176C11.3165 12.3548 10.9747 12.1107 10.5189 11.7852C10.0958 11.4271 9.8679 11.248 9.83535 11.248C5.864 8.35091 3.03197 6.2513 1.33926 4.94922C1.04629 4.72135 0.899805 4.41211 0.899805 4.02148V3.09375C0.899805 2.44271 1.12767 1.88932 1.5834 1.43359C2.03913 0.977865 2.59251 0.75 3.24356 0.75H23.5561C24.2071 0.75 24.7605 0.977865 25.2162 1.43359C25.6719 1.88932 25.8998 2.44271 25.8998 3.09375V4.02148C25.8998 4.41211 25.7533 4.72135 25.4604 4.94922C23.8653 6.1862 21.0333 8.28581 16.9643 11.248C16.9317 11.248 16.6876 11.4271 16.2318 11.7852C15.8087 12.1107 15.4831 12.3548 15.2553 12.5176C15.0274 12.6478 14.7182 12.8105 14.3275 13.0059C13.9695 13.1686 13.6602 13.25 13.3998 13.25Z'
                  fill='white'
                />
              </svg>
            </div>
            <div className=''>
              <p className='text-orange-500 text-sm font-raleway pl-3'>
                Email:
              </p>
              <span className='text-white text-sm font-raleway font-bold px-3 pr-4'>
                NGA.Enrichdlp@care.org
              </span>
            </div>
          </div>
        </div>

        {/* Bottom Footer Content */}
        <div className='grid grid-cols-1 md:grid-cols-4 gap-8 py-10 px-6 md:px-16'>
          {/* Logo and Social */}
          <div className='flex flex-col items-center text-center space-y-3'>
            <img
              src='/Care-logo.png'
              alt='Care eLearning'
              className='w-[150px] sm:w-[180px] md:w-[198px] h-auto'
            />
            <div className='text-center'>
              <p className='mb-4'>
                Follow us on any social platform to <br /> get latest updates
                and events.
              </p>
            </div>

            <div className='flex items-center space-x-2 '>
              {/* Facebook */}
              <div className='rounded-full bg-gray-600 px-2 w-[29px] h-[29px] flex items-center'>
                <svg
                  width='10'
                  height='18'
                  viewBox='0 0 10 18'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M8.61679 9.6875H6.12655V17.125H2.80624V9.6875H0.0835857V6.63281H2.80624V4.27539C2.80624 1.61914 4.39999 0.125 6.82382 0.125C7.98593 0.125 9.21445 0.357422 9.21445 0.357422V2.98047H7.85312C6.52499 2.98047 6.12655 3.77734 6.12655 4.64062V6.63281H9.08163L8.61679 9.6875Z'
                    fill='#E8721F'
                  />
                  <a href='https://web.facebook.com/CAREinNigeria/?_rdc=1&_rdr#' target='_blank' rel='noopener noreferrer'>
                    <rect
                      fill='black'
                      fill-opacity='0'
                      x='0.162687'
                      y='-1.275'
                      width='10.625'
                      height='19.55'
                    />
                  </a>
                </svg>
              </div>
              {/* Instagram */}
              <div className='rounded-full bg-gray-600 px-2 w-[29px] h-[29px] flex items-center'>
                <svg
                  width='16'
                  height='20'
                  viewBox='0 0 16 16'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M7.68632 3.80664C9.77812 3.80664 11.5047 5.5332 11.5047 7.625C11.5047 9.75 9.77812 11.4434 7.68632 11.4434C5.56132 11.4434 3.86796 9.75 3.86796 7.625C3.86796 5.5332 5.56132 3.80664 7.68632 3.80664ZM7.68632 10.1152C9.04765 10.1152 10.1434 9.01953 10.1434 7.625C10.1434 6.26367 9.04765 5.16797 7.68632 5.16797C6.29179 5.16797 5.19609 6.26367 5.19609 7.625C5.19609 9.01953 6.32499 10.1152 7.68632 10.1152ZM12.534 3.67383C12.534 4.17188 12.1355 4.57031 11.6375 4.57031C11.1394 4.57031 10.741 4.17188 10.741 3.67383C10.741 3.17578 11.1394 2.77734 11.6375 2.77734C12.1355 2.77734 12.534 3.17578 12.534 3.67383ZM15.0574 4.57031C15.1238 5.79883 15.1238 9.48438 15.0574 10.7129C14.991 11.9082 14.7254 12.9375 13.8621 13.834C12.9988 14.6973 11.9363 14.9629 10.741 15.0293C9.51249 15.0957 5.82695 15.0957 4.59843 15.0293C3.40312 14.9629 2.37382 14.6973 1.47734 13.834C0.614055 12.9375 0.34843 11.9082 0.282023 10.7129C0.215617 9.48438 0.215617 5.79883 0.282023 4.57031C0.34843 3.375 0.614055 2.3125 1.47734 1.44922C2.37382 0.585938 3.40312 0.320312 4.59843 0.253906C5.82695 0.1875 9.51249 0.1875 10.741 0.253906C11.9363 0.320312 12.9988 0.585938 13.8621 1.44922C14.7254 2.3125 14.991 3.375 15.0574 4.57031ZM13.4637 12.0078C13.8621 11.0449 13.7625 8.7207 13.7625 7.625C13.7625 6.5625 13.8621 4.23828 13.4637 3.24219C13.198 2.61133 12.7 2.08008 12.0691 1.84766C11.073 1.44922 8.74882 1.54883 7.68632 1.54883C6.59062 1.54883 4.2664 1.44922 3.30351 1.84766C2.63945 2.11328 2.1414 2.61133 1.87577 3.24219C1.47734 4.23828 1.57695 6.5625 1.57695 7.625C1.57695 8.7207 1.47734 11.0449 1.87577 12.0078C2.1414 12.6719 2.63945 13.1699 3.30351 13.4355C4.2664 13.834 6.59062 13.7344 7.68632 13.7344C8.74882 13.7344 11.073 13.834 12.0691 13.4355C12.7 13.1699 13.2312 12.6719 13.4637 12.0078Z'
                    fill='#E8721F'
                  />
                  <a href='https://www.instagram.com/care_ngr?igsh=MTc1amdpazVtNnRneQ' target='_blank' rel='noopener noreferrer'>
                    <rect
                      fill='black'
                      fill-opacity='0'
                      x='0.18925'
                      y='-1.275'
                      width='14.875'
                      height='19.55'
                    />
                  </a>
                </svg>
              </div>
              {/* Pinterest */}
              <div className='rounded-full bg-gray-600 px-2 w-[29px] h-[29px] flex items-center'>
                <svg
                  width='14'
                  height='17'
                  viewBox='0 0 14 17'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M7.07676 0.357422C10.1979 0.357422 13.0533 2.51562 13.0533 5.80273C13.0533 8.89062 11.4596 12.3438 7.94004 12.3438C7.07676 12.3438 6.04746 11.9121 5.61582 11.1484C4.88535 14.1367 4.91855 14.6016 3.2584 16.8926C3.09238 16.959 3.12559 16.959 3.02598 16.8262C2.95957 16.1953 2.89316 15.5977 2.89316 14.9668C2.89316 12.9414 3.82285 9.98633 4.2877 8.02734C4.02207 7.49609 3.95566 6.89844 3.95566 6.33398C3.95566 3.67773 7.07676 3.2793 7.07676 5.4707C7.07676 6.76562 6.18027 7.99414 6.18027 9.25586C6.18027 10.0859 6.91074 10.6836 7.74082 10.6836C10.0318 10.6836 10.7291 7.39648 10.7291 5.63672C10.7291 3.2793 9.06895 1.98438 6.77793 1.98438C4.15488 1.98438 2.12949 3.87695 2.12949 6.5332C2.12949 7.82812 2.92637 8.49219 2.92637 8.79102C2.92637 9.05664 2.72715 9.95312 2.39512 9.95312C1.59824 9.95312 0.30332 8.625 0.30332 6.30078C0.30332 2.61523 3.65684 0.357422 7.07676 0.357422Z'
                    fill='#E8721F'
                  />
                  <a href='https://x.com/CARE_Nigeria' target='_blank' rel='noopener noreferrer'>
                    <rect
                      fill='black'
                      fill-opacity='0'
                      x='0.173438'
                      y='-1.275'
                      width='12.75'
                      height='19.55'
                    />
                  </a>
                </svg>
              </div>
              {/* Twitter */}
              <div className='rounded-full bg-gray-600 px-2 w-[29px] h-[29px] flex items-center'>
                <svg
                  width='18'
                  height='15'
                  viewBox='0 0 18 15'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M15.4402 4.17188C15.4402 4.33789 15.4402 4.4707 15.4402 4.63672C15.4402 9.25195 11.9539 14.5312 5.5457 14.5312C3.55352 14.5312 1.72734 13.9668 0.200001 12.9707C0.465626 13.0039 0.731251 13.0371 1.03008 13.0371C2.65703 13.0371 4.15117 12.4727 5.34649 11.543C3.81914 11.5098 2.52422 10.5137 2.09258 9.11914C2.325 9.15234 2.52422 9.18555 2.75664 9.18555C3.05547 9.18555 3.3875 9.11914 3.65313 9.05273C2.05938 8.7207 0.864063 7.32617 0.864063 5.63281V5.59961C1.32891 5.86523 1.89336 5.99805 2.45781 6.03125C1.49492 5.40039 0.897266 4.33789 0.897266 3.14258C0.897266 2.47852 1.06328 1.88086 1.36211 1.38281C3.08867 3.47461 5.67852 4.86914 8.56719 5.03516C8.50078 4.76953 8.46758 4.50391 8.46758 4.23828C8.46758 2.3125 10.0281 0.751953 11.9539 0.751953C12.95 0.751953 13.8465 1.15039 14.5105 1.84766C15.2742 1.68164 16.0379 1.38281 16.702 0.984375C16.4363 1.81445 15.9051 2.47852 15.1746 2.91016C15.8719 2.84375 16.5691 2.64453 17.1668 2.37891C16.702 3.07617 16.1043 3.67383 15.4402 4.17188Z'
                    fill='#E8721F'
                  />
                  <a>
                    <rect
                      fill='black'
                      fill-opacity='0'
                      x='0.200001'
                      y='-1.275'
                      width='17'
                      height='19.55'
                    />
                  </a>
                </svg>
              </div>
            </div>
          </div>

          {/* Subsribe */}
          {/* <div className='flex flex-col  space-y-6'>
            <h3 className='font-raleway font-bold text-2xl'>Subscribe</h3>
            <input
              type='email'
              placeholder='Enter your email:'
              className='w-80 px-4 py-4 mb-3 rounded-sm font-raleway text-black'
            />

            <button className='bg-orange-500 text-white px-4 py-4 mr-[199px] rounded font-raleway hover:bg-orange-600 '>
              SUBSCRIBE NOW
            </button>
          </div> */}
          {/* Links */}
          <div className='flex flex-col items-center teaxt-center space-y-5'>
            <h3 className='text-2xl font-bold font-raleway mr-16'>Links</h3>
            <ul className='space-y-3 font-raleway ml-14'>
              {[
                { label: 'Courses', href: '/courses' },
                // { label: 'Become A Learner', href: '/courses' },
                { label: 'Become A Tutor', href: '/courses' },
                { label: 'About Us', href: '/about' },
                { label: 'Blog News', href: '/blog' },
              ].map((item, index) => (
                <li key={index}>
                  <a
                    href={item.href}
                    className='flex items-center space-x-6 hover:text-orange-500'
                  >
                    {/* SVG icon */}
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      className='w-4 h-4 text-white'
                      fill='none'
                      viewBox='0 0 24 24'
                      stroke='currentColor'
                    >
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth='2'
                        d='M9 5l7 7-7 7'
                      />
                    </svg>
                    <span>{item.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Google App*/}
          <div className='flex flex-col  space-y-6'>
            <div className='text-left'>
              <h3 className='font-raleway font-bold text-2xl pr-20'>
                Download
              </h3>
            </div>

            <div className='flex items-center justify-center py-6 space-x-3 '>
              <div className='w-14 h-14 flex items-center justify-center rounded-full border border-gray-400'>
                <svg
                  width='41'
                  height='41'
                  viewBox='0 0 41 41'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M20.5 7.16699H23.8333V17.167H28L20.5 24.667M20.5 7.16699H17.1667V17.167H13L20.5 24.667'
                    fill='white'
                  />
                  <path
                    d='M20.5 7.16699H23.8333V17.167H28L20.5 24.667L13 17.167H17.1667V7.16699H20.5Z'
                    stroke='white'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                  <path
                    d='M10.5 32.167H30.5'
                    stroke='white'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                </svg>
              </div>
              <div className='text-left'>
                <img
                  src='./Google Play.png'
                  alt='Thumb 1'
                  className=' h-[62px] w-[290px]'
                />
              </div>
            </div>
          </div>
        </div>
      </footer>

      <footer className='w-full h-[70.3px] bg-black space-y-4 py-16 px-6 md:px-20'>
        <div className='flex justify-center text-center'>
          <div className=' text-white text-center font-raleway text-sm'>
            Copyright © 2026{' '}
            <span className='text-orange-500'>CARE Nigeria</span> || All Rights
            Reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Contactos;
